import { textStyles as o } from "../../textStyles.es.js";
import { transformPxToRem as r } from "../../../utils/units.es.js";
import { createMultiStyleConfigHelpers as t } from "@chakra-ui/react";
import { TabsAnatomy as e } from "./Tabs.anatomy.es.js";
const { definePartsStyle: a, defineMultiStyleConfig: i } = t(
  e.keys
), l = a({
  badge: {
    backgroundColor: "error.500",
    color: "white",
    textAlign: "center",
    fontWeight: "semibold",
    lineHeight: r(12),
    fontSize: "sm",
    margin: "auto",
    paddingX: "spacing-50",
    paddingY: "spacing-25",
    borderRadius: "radius-25"
  },
  tab: {
    gap: "spacing-50",
    ...o.lg,
    height: "size-500",
    borderBottomWidth: "2px",
    flexDirection: "row",
    color: "primary.600",
    borderBottomColor: "transparent",
    borderBottomStyle: "solid",
    outline: "3px solid transparent",
    padding: 0,
    _dark: {
      color: "primary.200"
    },
    _last: {
      marginRight: 0
    },
    _hover: {
      borderBottomStyle: "solid",
      borderBottomColor: "primary.500",
      bg: "transparent",
      outline: "3px solid transparent",
      _dark: {
        borderBottomColor: "primary.300"
      }
    },
    _selected: {
      fontWeight: "500",
      borderBottomStyle: "solid",
      borderBottomColor: "secondary.500",
      outline: "3px solid transparent",
      color: "primary.500",
      _dark: {
        color: "white"
      },
      _hover: {
        borderBottomColor: "secondary.500"
      }
    },
    _disabled: {
      color: "primary.200",
      cursor: "not-allowed",
      _dark: {
        color: "primary.300"
      }
    }
  },
  tablist: {
    display: "flex",
    gap: "spacing-300",
    borderBottom: "1px solid",
    borderBottomColor: "primary.100"
  },
  tabpanel: {
    padding: 0
  },
  tabpanels: {
    marginTop: 6,
    padding: 0
  }
}), m = i({
  baseStyle: l
});
export {
  m as Tabs
};
//# sourceMappingURL=Tabs.es.js.map
